import app from '@src/helpers/app';
import getUri from '@src/helpers/getUri';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

const managerDashboardPermissions = [
    'users@is-manager',
    'manager-dashboard@can-see-dashboard',
];

const productionDashboardPermissions = [
    'users@is-production',
    'production-dashboard@can-see-dashboard',
];

export function getProductionDashboardUrlIfPossible(productId: number | string | null | undefined = null) {
    const user = app('auth').getUser();

    if (user && user.canAny(managerDashboardPermissions)) {
        return getUri(
            getDashboardEndpoint('manager-order-product-page', productId),
            'dashboards@manager'
        );
    }

    if (user && user.canAny(productionDashboardPermissions)) {
        return getUri(
            getDashboardEndpoint('production-order-product-page', productId),
            'dashboards@production'
        );
    }

    return null;
}
